import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router";

interface Props {
    userUnitId: number;
}

interface State {}

class MyUnitRedirectView extends Component<Props, State> {
    state = {};

    render() {
        if (!this.props.userUnitId) {
            return <Redirect to={"/"} />;
        }

        const url = `/avdelningar/v/${this.props.userUnitId}`;
        return <Redirect to={url} />;
    }
}

const mapStateToProps = (state, props) => {
    return {
        ...props,

        userUnitId: state.profile.active?.department?.id,
    };
};

// @ts-ignore
export default withRouter(connect(mapStateToProps)(MyUnitRedirectView));
